module.exports = __webpack_public_path__ + "img/李志军.3b636241.jpg";